import { useRequestGetVerificationsCount } from '@/hooks/httpRequest';
import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { VerificationTypesEnum } from '@/lib/enum';

const useVerificationsCount = () => {

  const result = useRequestGetVerificationsCount({ 
    additionalCheckStatus: VerificationAdditionalCheckStatusEnum.WITHOUT_STATE,
    type: VerificationTypesEnum.PROFILE_PHOTO
  });

  return result;

};

export default useVerificationsCount;
